import { GenIcon } from '../helpers/IconBase.es.js';

const TimeForwardOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_2753_2749)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M15.3331 7.33333C15.1563 7.33333 14.9868 7.40357 14.8617 7.5286C14.7367 7.65362 14.6665 7.82319 14.6665 8C14.6719 9.55018 14.1388 11.0541 13.1582 12.2548C12.1776 13.4554 10.8104 14.2782 9.29041 14.5825C7.77038 14.8869 6.19184 14.6538 4.82461 13.9232C3.45737 13.1927 2.38631 12.0099 1.7945 10.5771C1.2027 9.14433 1.12689 7.55049 1.58003 6.06801C2.03317 4.58552 2.98713 3.30644 4.27885 2.44938C5.57057 1.59232 7.11986 1.2105 8.66191 1.36918C10.204 1.52786 11.643 2.21718 12.7331 3.31933C12.7112 3.32531 12.689 3.32999 12.6665 3.33333H10.6665C10.4897 3.33333 10.3201 3.40357 10.1951 3.5286C10.0701 3.65362 9.99982 3.82319 9.99982 4C9.99982 4.17681 10.0701 4.34638 10.1951 4.47141C10.3201 4.59643 10.4897 4.66667 10.6665 4.66667H12.6665C13.1969 4.66667 13.7056 4.45595 14.0807 4.08088C14.4558 3.70581 14.6665 3.1971 14.6665 2.66667V0.666667C14.6665 0.489856 14.5962 0.320286 14.4712 0.195262C14.3462 0.0702379 14.1766 0 13.9998 0C13.823 0 13.6534 0.0702379 13.5284 0.195262C13.4034 0.320286 13.3331 0.489856 13.3331 0.666667V2.04333C11.9682 0.82302 10.2258 0.108111 8.39705 0.0180684C6.56834 -0.0719742 4.76411 0.468305 3.28587 1.54862C1.80762 2.62894 0.744905 4.18386 0.275299 5.95354C-0.194308 7.72322 -0.0423553 9.60046 0.705764 11.2716C1.45388 12.9427 2.75285 14.3064 4.3856 15.1349C6.01836 15.9634 7.88599 16.2065 9.67641 15.8235C11.4668 15.4405 13.0716 14.4547 14.2225 13.0307C15.3734 11.6067 16.0008 9.83093 15.9998 8C15.9998 7.82319 15.9296 7.65362 15.8046 7.5286C15.6795 7.40357 15.51 7.33333 15.3331 7.33333Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M8.00016 4C7.82335 4 7.65378 4.07024 7.52876 4.19526C7.40373 4.32029 7.3335 4.48986 7.3335 4.66667V8C7.33353 8.1768 7.4038 8.34634 7.52883 8.47133L9.52883 10.4713C9.65456 10.5928 9.82297 10.66 9.99776 10.6584C10.1726 10.6569 10.3398 10.5868 10.4634 10.4632C10.587 10.3396 10.6571 10.1724 10.6586 9.9976C10.6601 9.8228 10.5929 9.6544 10.4715 9.52867L8.66683 7.724V4.66667C8.66683 4.48986 8.59659 4.32029 8.47157 4.19526C8.34654 4.07024 8.17697 4 8.00016 4Z",
              fill: "black"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_2753_2749" },
            child: [
              {
                tag: "rect",
                attr: { width: "16", height: "16", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { TimeForwardOutlined };
